import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCandidateForSideDrawerSuccess } from '@shared/candidate/side-nav-candidate/store/candidate-side-nav.actions';
import { CandidateAdapter } from '@shared';
import { SideNavService } from '@shared/candidate/side-nav-candidate/services/side-nav.service';
import { attachmentsGetLatestResume } from '@collections/attachments';
import { candidatesGetSuccess } from '@collections/candidates';

@Component({
  selector: 'mojo-candidate-side-nav-container',
  templateUrl: './side-nav-candidate-view.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavCandidateViewContainerComponent implements OnDestroy {
  _sidebarOpened: boolean;
  get sidebarOpened(): boolean {
    return this._sidebarOpened;
  }

  @Input() set sidebarOpened(value: boolean) {
    this._sidebarOpened = value;
    if (!!value) {
      this.loadDataForCandidate();
    }
  }
  @Output() closeEmitter = new EventEmitter<void>();
  @Input() selectedCandidate: CandidateAdapter;
  @Input() sideDrawerCandidatesList: CandidateAdapter[];
  @Input() jobId?: number;
  @Input() talentPoolId?: number;
  @Input() fromDashboardLanding = false;
  @Input() fromTalentPool = false;

  isNextButtonDisabled: boolean;
  isPreviousDisabled: boolean;
  close() {
    this.sideNavService.setCandidateId(null);
    this.closeEmitter.emit();
  }

  findCandidateIndex() {
    return this.sideDrawerCandidatesList.findIndex(({ id }) => id === this.selectedCandidate.id);
  }

  loadProperCandidate(number) {
    const index = this.findCandidateIndex() + number;
    this.selectedCandidate = this.sideDrawerCandidatesList[index];
    this.loadDataForCandidate();
  }

  setButtonsDisabledValues() {
    this.isNextButtonDisabled =
      this.findCandidateIndex() === this.sideDrawerCandidatesList.length - 1;
    this.isPreviousDisabled = this.findCandidateIndex() === 0;
  }

  loadDataForCandidate() {
    this.setButtonsDisabledValues();
    if (this.fromDashboardLanding) {
      this.store.dispatch(
        candidatesGetSuccess({ payload: this.selectedCandidate.sourceCandidate }),
      );
    }
    this.store.dispatch(selectCandidateForSideDrawerSuccess({ id: this.selectedCandidate.id }));
    this.store.dispatch(
      attachmentsGetLatestResume({
        payload: {
          candidateId: this.selectedCandidate.id,
          onlyPdfFiles: true,
        },
      }),
    );
    this.sideNavService.setCandidateId(this.selectedCandidate.id);
  }

  constructor(private store: Store, private sideNavService: SideNavService) {}

  ngOnDestroy() {
    this.sideNavService.setCandidateId(null);
  }
}
